import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { FormattedCurrency } from '../../../../iwIntlProvider/FormattedCurrency';
import { SHOW_REPAYMENT_SCHEDULE_MODAL } from '../../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper';
import PairItemContainer from '../../../ui/pairItemContainer/PairItemContainer';

import styles from './ConfirmForm.module.css';
import messages from '../ConfirmFundingView.messages';
import { getOutstandingBalanceOnCurrentDay } from '../../../drawDown/DrawDownSelectors';
import NextRepayment from '../../../funding/ConfirmFundingView/confirmForm/nextRepayment/NextRepayment';
import { Button } from '@iwoca/orion';
import { CONFIRM_FUNDING } from '../../Funding.actions';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';

const mapStateToProps = (state: RootState) => {
    return {
        outstandingBalanceOnCurrentDay: getOutstandingBalanceOnCurrentDay(state)
    };
};

const confirmDrawdownForm = {
    form: 'confirmDrawdown',
    enableReinitialize: true
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    confirm: (offerId: string) =>
        dispatch({
            type: CONFIRM_FUNDING,
            amount: 0,
            offerId
        }),
    showSchedule: () => dispatch({ type: SHOW_REPAYMENT_SCHEDULE_MODAL })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type TProps = {
    offerId: string;
};

const Confirm = ({
    confirm,
    showSchedule,
    outstandingBalanceOnCurrentDay,
    offerId
}: TProps & PropsFromRedux) => {
    const totalOutstandingBalance = outstandingBalanceOnCurrentDay;

    return (
        <div className={styles.Confirm}>
            <MainSectionWrapper className={styles.content}>
                <PairItemContainer>
                    <div className={styles.selectedAmount}>
                        <div className={styles.summaryTitle}>
                            <FormattedMessage
                                {...messages.summaryTitleInterestOnly}
                            />
                        </div>
                        <div>
                            <FormattedMessage
                                {...messages.summaryBreakdownTopUp}
                                values={{
                                    newBalance: (
                                        <span
                                            className={styles.summaryTotalCost}
                                        >
                                            <FormattedCurrency
                                                value={totalOutstandingBalance}
                                            />
                                        </span>
                                    )
                                }}
                            />
                        </div>
                    </div>

                    <div className={styles.repayments}>
                        <NextRepayment />
                        <div className={styles.showSchedule}>
                            <span
                                className={styles.link}
                                onClick={showSchedule}
                            >
                                <FormattedMessage
                                    {...messages.repaymentBreakdown}
                                />
                            </span>
                        </div>
                    </div>
                </PairItemContainer>
            </MainSectionWrapper>
            <div className={styles.newFundingConfirmButton}>
                <Button
                    variant="success"
                    onClick={() => confirm(offerId)}
                    size="large"
                    data-action-name="Confirm funding"
                >
                    <FormattedMessage {...messages.confirm} />
                </Button>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm<any, TProps & PropsFromRedux>(confirmDrawdownForm)(Confirm));
